import { render } from "./TheTeleport.vue?vue&type=template&id=52a55062"
import script from "./TheTeleport.vue?vue&type=script&lang=js"
export * from "./TheTeleport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__